import './LfBtn.css';

const LfBtn=(props)=> {
    return(
        <button class='lfbtn'><a href="#">{props.text}</a> </button>
    )
}

export default LfBtn;